interface Props {
  label: string;
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}

/** A single-choice question drawn as tiles (prototype .tq .tiles); a second click clears the answer. */
function TileChoice({ label, options, value, onChange }: Props) {
  return (
    <div className="plg-choice" role="group" aria-label={label}>
      {label && <div className="plg-choice__label">{label}</div>}
      {/* Four answers sit on one row (prototype .tiles.four); fewer share an auto-fit grid (.tq .tiles). */}
      <div className={`plg-choice__tiles${options.length === 4 ? " plg-choice__tiles--four" : ""}`}>
        {options.map((o) => {
          const on = value === o.value;
          return (
            <button
              type="button"
              key={o.value}
              className={`plg-choice__tile${on ? " is-on" : ""}`}
              aria-pressed={on}
              onClick={() => onChange(on ? "" : o.value)}
            >
              <span className="plg-choice__tick" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path d="M5 12l5 5 9-10" />
                </svg>
              </span>
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TileChoice;
